"use strict";

import "babel-polyfill";
window._ = require( 'lodash' );

let update = function ( arr, key, newval ) {
    let match = _.find( arr, key );
    if ( match ) {
        let index = _.indexOf( arr, _.find( arr, key ) );
        arr.splice( index, 1, newval );
    } else {
        arr.push( newval );
    }
};

_.mixin( { '$update': update } );

require( 'bootstrap-sass' );

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

import Vue from 'vue';
import VueResource from "vue-resource";
import VeeValidate from "vee-validate";
import Vuex from "vuex";
import VueRouter from "vue-router";
import Snotify, { SnotifyPosition } from 'vue-snotify'
import VModal from 'vue-js-modal'

import DepartmentsMenu from './../components/app/departments/departments-menu';
import Product from './../components/app/products/product';
import ProductGrid from './../components/app/products/productGrid';
import SearchBar from './../components/app/navigation/search-bar';
import TopBar from './../components/app/navigation/top-bar';
import GrotecFooter from '../components/app/navigation/grotec-footer';
import HiddenMenu from './../components/app/departments/hidden-menu'
import Cart from "../components/cart/cart";
import CartItem from "../components/cart/cart-item";

Vue.use( VueResource );
Vue.use( VeeValidate );
Vue.use( Vuex );
Vue.use( VueRouter );
const snotifyOptions = {
    toast: {
        position: SnotifyPosition.rightTop
    }
};

Vue.use( Snotify, snotifyOptions );

const modalOptions = {
    dynamic: true,
    pivotY: 0.2
};

Vue.use( VModal, modalOptions );

/**
 * Load API KEY
 */
const grotecConfig = require( './../config.js' ).default;

/**
 * We'll register a HTTP interceptor to attach the "CSRF" header to each of
 * the outgoing requests issued by this application. The CSRF middleware
 * included with Laravel will automatically verify the header's value.

 */

Vue.http.interceptors.push( function ( request, next ) {
    request.headers.set( 'X-CSRF-TOKEN', Laravel.csrfToken );
    request.headers.set( 'Authorization', 'Bearer ' + grotecConfig.api.key );
    request.headers.set( 'X-Requested-With', 'XMLHttpRequest');
    next();
} );
// default image
let defaultImg = new Image();
defaultImg.src = '/img/default-product.png';

//pre-loader
let preloadImage = ( el, binding ) => {
    let img = new Image();

    img.src = binding.value;

    img.onload = () => {
        el.src = img.src;
        $( el )
            .css( 'opacity', 0 )
            .animate( { opacity: 1 }, 500 )
    };
};

let imgCanvas = ( el, binding ) => {
    /// step 1 - resize to 50%
    el.innerHTML = "";
    let oc = document.createElement( 'canvas' );
    oc.classList.add('center-block');
    let octx = oc.getContext( '2d' );

    oc.width = 175;
    oc.height = 175;

    let img = new Image();

    img.onload = () => {
        octx.drawImage( img, 0, 0, oc.width, oc.height );
        el.appendChild( oc );
    };
    img.onerror = () => {
        octx.drawImage( defaultImg, 0, 0, oc.width, oc.height );
        el.appendChild( oc );
    };

    img.src = binding.value;
    img.setAttribute('itemprop', 'image');
};

Vue.directive( 'img', {
    bind: preloadImage,
    componentUpdated: preloadImage
} );

Vue.directive( 'canvas', {
    bind: imgCanvas,
    componentUpdated: imgCanvas
} );

/**
 * The departments and products components, they're used
 * throughout the site so should be brought in here
 */

Vue.component( 'search-bar')
Vue.component( 'departments-menu', DepartmentsMenu );
Vue.component( 'product', Product );
Vue.component( 'productGrid', ProductGrid );
Vue.component( 'search-bar', SearchBar );
Vue.component( 'top-bar', TopBar );
Vue.component( 'grotec-footer', GrotecFooter );
Vue.component( 'hidden-menu', HiddenMenu );
Vue.component('cart', Cart);
Vue.component('cart-item', CartItem);

window.Vue = Vue
/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from "laravel-echo"

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'your-pusher-key'
// });
